import { render, staticRenderFns } from "./DialogTerrainSearchBasicWidget.vue?vue&type=template&id=36bef62d&scoped=true&"
import script from "./DialogTerrainSearchBasicWidget.vue?vue&type=script&lang=js&"
export * from "./DialogTerrainSearchBasicWidget.vue?vue&type=script&lang=js&"
import style0 from "./DialogTerrainSearchBasicWidget.vue?vue&type=style&index=0&id=36bef62d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bef62d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
